module.exports = __webpack_public_path__ + "static/media/svgback.077dac8d.svg";